import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Stack, Typography } from '@mui/material';
import classNames from 'classnames';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import ReactDOM from 'react-dom';
import styles from './styles.module.css';
@autobind
export default class Popup extends Component {
    static propTypes = {
        onClose: PropTypes.func,
        children: PropTypes.node,
        stretch: PropTypes.bool,
        className: PropTypes.string,
        visible: PropTypes.bool.isRequired,
        showCloseIcon: PropTypes.bool,
        disablePadding: PropTypes.bool,
        onGoBack: PropTypes.func,
        title: PropTypes.string,
        showBackIcon: PropTypes.bool,
        dataTestId: PropTypes.string,
    };

    static defaultProps = {
        showCloseIcon: true,
        disablePadding: false,
    };

    constructor(props) {
        super(props);
        this.container = document.createElement('div');
    }

    componentDidMount() {
        const popupRoot = document.getElementById('popup');
        popupRoot.appendChild(this.container);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.visible && nextProps.visible) {
            this.addListeners();
        } else if (this.props.visible && !nextProps.visible) {
            this.removeListeners();
        }
    }

    componentWillUnmount() {
        const popupRoot = document.getElementById('popup');
        popupRoot.removeChild(this.container);
        if (this.props.visible) this.removeListeners();
    }

    addListeners() {
        try {
            document.activeElement.blur();
        } catch (error) {
            // noop
        }
        document.addEventListener('keydown', this.handleEscPress);
    }

    removeListeners() {
        document.removeEventListener('keydown', this.handleEscPress);
    }

    handleEscPress(event) {
        if (event.keyCode === 27) this.handleClose();
    }

    handleClose() {
        if (this.props.onClose) this.props.onClose();
    }

    render() {
        if (!this.props.visible) return null;
        return ReactDOM.createPortal(
            <div className={styles.root}>
                <div className={styles.overlay} onClick={this.handleClose} />
                <div
                    className={classNames(styles.modal, this.props.className, {
                        [styles.stretch]: this.props.stretch,
                        [styles.disablePadding]: this.props.disablePadding,
                    })}
                    data-testid={this.props.dataTestId}
                >
                    <Stack
                        direction='row'
                        justifyContent='space-between'
                        alignItems='center'
                        sx={{ mt: 1, flexWrap: 'nowrap' }}
                    >
                        <Stack>
                            {this.props.onGoBack && this.props.showBackIcon && (
                                <IconButton onClick={this.props.onGoBack} sx={{ ml: 0.5 }}>
                                    <ArrowBackIcon sx={{ fontSize: 20 }} />
                                </IconButton>
                            )}
                        </Stack>
                        <Typography
                            color='primary'
                            align='center'
                            variant='h6'
                            sx={{
                                fontWeight: 500,
                                px: 2,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                flex: '1 1 auto',
                            }}
                        >
                            {this.props.title}
                        </Typography>
                        <Stack
                            direction='row'
                            justifyContent='flex-end'
                            sx={{ width: this.props.onGoBack && this.props.showBackIcon ? 40 : 0 }}
                        >
                            {this.props.onClose && this.props.showCloseIcon && (
                                <IconButton onClick={this.props.onClose} sx={{ mx: 0.5 }}>
                                    <CloseIcon sx={{ fontSize: 20 }} />
                                </IconButton>
                            )}
                        </Stack>
                    </Stack>

                    {this.props.children}
                </div>
            </div>,
            this.container
        );
    }
}
